import { isYesterday } from "date-fns";
export class ClockWorkRunningEntryModel {
    constructor() {
        this.timeDurationDisplay = "";
    }
    get enableCrossover() {
        var dateformat = new Date(this.clockWorkEntry.startTime);
        // const diffTime = Math.abs(new Date(dateformat.toLocaleDateString()).getTime() - new Date(new Date().toLocaleDateString()).getTime());
        // if (Math.ceil(diffTime / (1000 * 3600 * 24)) == 1) {
        //     return false;
        // }
        if (isYesterday(dateformat)) {
            return false;
        }
        return true;
    }
    get dateFormatEntries() {
        const date = new Date(this.clockWorkEntry.startTime);
        var options = { weekday: "long", year: "numeric", month: "short", day: "numeric" };
        return date.toLocaleString("en-US", options);
    }
    get formattedDate() {
        const date = new Date(this.clockWorkEntry.startTime);
        var options = { year: "numeric", month: "short", day: "numeric" };
        return date.toLocaleString("en-US", options);
    }
}
export default class ClockWorkRunningEntry extends ClockWorkRunningEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
